export default __webpack_public_path__ + "resources/icons/d310-3f1a.png";